module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAOCAMAAAAVBLyFAAAASFBMVEVMaXGGhpN/g5OJiZyAg5N/g5N/hpN+g5R/g5N/hJN+g5N/g5R+gpN/hJN7g5J/g5N/hJJ9gZSAhJN/hJR/hJOBhJN/g5SAhJRXnfltAAAAF3RSTlMAE7YNq/Am+ejaYdDHoiG8kE+Dd2ZTPM140oYAAAB7SURBVHjaPctZEsIwDATRiZfIDtm3vv9NgQjzvlRdI0nxGI28DPq7C672cr1RAhAKpfOUYI9GjiusnjJggJUU0vD8Gi4EvpZPHPGz4sqsjUeCYaXORpIOgPqCbFDAJE2emixpPPtt2Gkm/cQ2q52abjKA7KXF67zuNOsNQikMPEa/FfUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/icon-weixin.png
// module id = kiD0
// module chunks = 0